import React from "react";
import f1 from "./assets/img/features-1.png"
import f2 from "./assets/img/features-2.png"
import f3 from "./assets/img/features-3.png"
import f4 from "./assets/img/features-4.png"

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

const Feacher = () =>{
    return (
        <section id="features" class="features">
      <div class="container">

        <div class="row">
          <div class="col-lg-6 mt-2 mb-tg-0 order-2 order-lg-1">
            <ul class="nav nav-tabs flex-column">
              <li class="nav-item" data-aos="">
                <a class="nav-link active show" data-bs-toggle="tab" href="#tab-1">
                  <h4>Meet to the Client</h4>
                  <p></p>
                </a>
              </li>
              <li class="nav-item mt-2" data-aos="" data-aos-delay="">
                <a class="nav-link" data-bs-toggle="" href="#tab-2">
                  <h4>Planing and Design Layouts</h4>
                  <p></p>
                </a>
              </li>
              <li class="nav-item mt-2" data-aos="" data-aos-delay="">
                <a class="nav-link" data-bs-toggle="" href="#tab-3">
                  <h4>Development and Testing </h4>
                  <p></p>
                </a>
              </li>
              <li class="nav-item mt-2" data-aos="" data-aos-delay="">
                <a class="nav-link" data-bs-toggle="" href="#tab-4">
                  <h4>Launch and Deliver to Clients</h4>
                  <p></p>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-6 order-1 order-lg-2" data-aos="">
            <div class="tab-content">
              <div class="tab-pane active show" id="tab-1">
                <figure>
                  <img src={f1} alt="" class="img-fluid"/>
                </figure>
              </div>
              <div class="tab-pane" id="tab-2">
                <figure>
                  <img src={f2} alt="" class="img-fluid"/>
                </figure>
              </div>
              <div class="tab-pane" id="tab-3">
                <figure>
                  <img src={f3} alt="" class="img-fluid"/>
                </figure>
              </div>
              <div class="tab-pane" id="tab-4">
                <figure>
                  <img src={f4} alt="" class="img-fluid"/>
                </figure>
              </div>
            </div>
          </div>
        </div>

      </div>
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
    {/* <!-- ads1 --> */}
    <ins class="adsbygoogle"
        //  style={"display:block"}
         data-ad-client="ca-pub-1937777226188556"
         data-ad-slot="8353628701"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
    <script>
         (adsbygoogle = window.adsbygoogle || []).push({});
    </script>
    </section>
    
    )
}

export default Feacher;